import React from 'react';
import '../../styles/components/profile_page/GalleryGrid.css';

export default function GalleryGrid({
  photos = [],
  isOwner = false,
  selecting = false,
  selected = new Set(),
  onToggleSelect,
  onDelete,
  onClickPhoto,
  onSetCover,
  onToggleVisibility,
  gridRef,                 // NEW: forwarded ref for measurements
}) {
  return (
    <div className="gallery-grid" ref={gridRef}>
      {photos.map((p, i) => {
        const url = p.url || '';
        const isSelected = selected?.has?.(url);
        const handleClick = () => {
          if (selecting) onToggleSelect?.(url);
          else onClickPhoto?.(i);
        };
        return (
          <div
            key={url || i}
            className={`gallery-item ${isSelected ? 'is-selected' : ''}`}
            onClick={handleClick}
            draggable={!selecting}
            onDragStart={(e) => {
              e.dataTransfer.setData('text/json', JSON.stringify({ photoIds: [url] }));
            }}
          >
            <img src={url} alt={p.alt || ''} loading="lazy" />

            {selecting && (
              <div className="select-checkbox" onClick={(e)=>{e.stopPropagation(); onToggleSelect?.(url);}}>
                <input type="checkbox" readOnly checked={isSelected} />
              </div>
            )}

            {isOwner && !selecting && (
              <div className="gallery-actions" onClick={(e)=>e.stopPropagation()}>
                <button title="Set cover" onClick={() => onSetCover?.(url)}>⭐</button>
                <button title="Hide/Show" onClick={() => onToggleVisibility?.(url)}>👁</button>
                <button title="Delete" className="danger" onClick={() => onDelete?.(url)}>🗑</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
